import React, {useState} from 'react';
import Helmet from 'react-helmet';
import {Button, TextField, Card, CardActions, CardContent, CardHeader} from '@material-ui/core';
import {firstTimeLoginResetPassword} from 'util/Authentication';

const styles = {
  span: {
    fontSize: 10,
  },
  p: {
    color: 'red',
    padding: '0px 20px',
    fontSize: 14,
  },
};

export default function FirstTimeLoginReset(props) {
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const handleChangePassword = ({target: {value}}) => setPassword(value);
  const handleSubmit = async () => {
    setErrorMessage('');
    if (password !== '') {
      try {
        await firstTimeLoginResetPassword(password);
      } catch (e) {
        setErrorMessage(e.message);
      }
    }
  };

  return (
    <div
      className="login_bg"
      style={{
        backgroundSize: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '0% 30%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <Helmet title="myOzgene" defer={false} />
      <Card
        style={{
          marginTop: '20px',
          padding: '20px 20px 20px 20px',
          backgroundColor: 'white',
          width: '300px',
        }}
      >
        <img
          src="/ozgene_logo.png"
          alt="logo"
          width="200"
          height="60"
          style={{
            marginRight: 'auto',
            marginLeft: 'auto',
            display: 'block',
          }}
        />

        <CardHeader title="Reset myOzgene password" />
        <p style={styles.p}>{errorMessage}</p>
        <CardContent>
          <span style={{fontSize: 'smaller'}}>Please enter a new password.</span>
          <br />
          <TextField
            type="password"
            fullWidth
            placeholder="Enter your new Password"
            label="New Password"
            onChange={handleChangePassword}
          />
          <span style={styles.span}>Minimum 8 characters (alpha-numeric)</span>
        </CardContent>
        <CardActions>
          <Button color="primary" variant="outlined" onClick={handleSubmit}>
            Create New Password
          </Button>
        </CardActions>
      </Card>
    </div>
  );
}
